import api from "../axios_service.js";

export async function getVendasStatus(filtros) {
  const response = await api.get(
    `/graficos/vendas-status${filtros ? filtros : ""}`
  );
  return response.data.result;
}
